var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 11.8333C8.73622 11.8333 9.33317 12.4303 9.33317 13.1667C9.33317 13.903 8.73622 14.5 7.99984 14.5C7.26346 14.5 6.6665 13.903 6.6665 13.1667C6.6665 12.4303 7.26346 11.8333 7.99984 11.8333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 7.16667C8.73622 7.16667 9.33317 7.76362 9.33317 8.5C9.33317 9.23638 8.73622 9.83333 7.99984 9.83333C7.26346 9.83333 6.6665 9.23638 6.6665 8.5C6.6665 7.76362 7.26346 7.16667 7.99984 7.16667Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 2.5C8.73622 2.5 9.33317 3.09695 9.33317 3.83333C9.33317 4.56971 8.73622 5.16667 7.99984 5.16667C7.26346 5.16667 6.6665 4.56971 6.6665 3.83333C6.6665 3.09695 7.26346 2.5 7.99984 2.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDots);
export default __webpack_public_path__ + "static/media/menu-dots.62b0f7b5afc1c9b39014a0c7d51cc875.svg";
export { ForwardRef as ReactComponent };